import { Suspense, lazy } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { ProtectedRoute, useAuth } from '../../../../shared/ui';
import { UserRole } from '../../../../shared/utils/types';
import { NotFoundPage } from '../../pages/NotFoundPage';

const AdminRewardRulesPage = lazy(() =>
  import('../../pages/admin/AdminRewardRulesPage').then(m => ({
    default: m.AdminRewardRulesPage,
  }))
);

const ProtectedAdminRewardRulesPage = () => {
  const { user } = useAuth();
  if (user?.role !== UserRole.ADMIN) return <NotFoundPage />;
  return (
    <ProtectedRoute>
      <Suspense fallback={<div>Loading...</div>}>
        <AdminRewardRulesPage />
      </Suspense>
    </ProtectedRoute>
  );
};

export const Route = createFileRoute('/admin/reward-rules')({
  beforeLoad: () => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      throw redirect({ to: '/login' });
    }
  },
  component: ProtectedAdminRewardRulesPage,
});
